import React from 'react';
import { Alert, Flex } from 'antd';
import { useExtensionInstalled } from '../useExtensionInstalled';
import { GetExtension, ReviewInExtension } from './ReviewInExtension';

/**
 * The last step of the first-run flow on the website: reviews do not happen here, so a new
 * learner is told where they do. With the extension already installed they can open the review
 * window right away; without it, they get the way to install it.
 */
export const AfterOnboarding: React.FC<{ storeUrl?: string }> = ({ storeUrl }) => {
  const installed = useExtensionInstalled();

  if (installed === true) {
    return (
      <Flex vertical gap={12} align="flex-start">
        <Alert
          type="success"
          showIcon
          title="The LingoPing extension is installed"
          description="Your reviews happen in the extension."
        />
        <ReviewInExtension />
      </Flex>
    );
  }

  return (
    <Alert
      type="info"
      showIcon
      title="Install the extension to review your words"
      description={
        <Flex vertical gap={8} align="flex-start">
          <span>
            Reviews happen in the LingoPing extension for Chrome. Sign in there with the same Google
            account.
          </span>
          {installed === false && <GetExtension storeUrl={storeUrl} />}
        </Flex>
      }
    />
  );
};
